import axios from "axios";

const api_url = process.env.API_URL;

import router from '../router';

import chalk from 'chalk';

import { useAuthStore } from '@/stores/authStore.js';
import {useSocketStore} from "@/stores/socketConnectionStore.js";


export default(url=`${api_url}`) => {
    const authService = useAuthStore();

    let instance = axios.create({
        baseURL: url,
    })

    instance.interceptors.request.use(
        async (config) => {
          console.log(`${config.method.toUpperCase()} ${chalk.green('Request')} ${chalk.blue.underline(api_url + config.url)}`);
          if(config.data){
            console.log(config.data);
          }
          const { useAuthStore } = await import('@/stores/authStore');
            const authStore = useAuthStore();
            const token = authStore.token;
        
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
        
            return config;
          },
          (error) => {
            return Promise.reject(error);
          }
    );

    instance.interceptors.response.use(
      response => {
        console.log(`${chalk.cyan('Response')} ${chalk.blue.underline(api_url + response.config.url)}`);
        if(response.data)
          console.log(response.data);
        return response;
      },
      error => {
        const socketService = useSocketStore();

        if (error.response.status === 401) {
          authService.logout();
          router.push('/login');
        }
        else if (error.response.status === 400) {
            socketService.handleSocketError({
                header: "Произошла ошибка",
                message: `${error.response?.data?.message}`,
            });
        }
        else if (error.response.status === 404) {
            socketService.handleSocketError({
                header: "Произошла ошибка сервера",
                message: "Запрашиваемый ресурс не найден",
            });
        }
        else if (error.response.status === 504) {
            socketService.handleSocketError({
                header: "Произошла ошибка сервера",
                message: "Время ожиадания ответа истекло. Попробуйте позже",
            });
        }
        else {
            socketService.handleSocketError({
                header: "Произошла ошибка сервера",
                message: error.response?.data?.sentry_code
                    ? `Обратитесь к оператору\nКод ошибки: ${error.response?.data?.sentry_code}`
                    : 'Произошла неизвестная ошибка',
                sentry: error.response?.data?.sentry_code || false,
            });
        }
        return Promise.reject(error);
      }
    );

    return instance;
}